export enum DeviceType {
  MOBILE = '1',
  WEB = '2',
  TABLET = '3',
  DESKTOP = '4',
}
